var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},_vm._l((_vm.componentList),function(item,index){return _c('div',{key:index,staticClass:"content-box"},[_c('ContentTitle',{attrs:{"information":item,"items":_vm.componentData && _vm.componentData[item.component]}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }